/**
 * Detects crawlers, headless renderers, and performance probes from the
 * User-Agent. Used to skip purely-cosmetic loading gates (e.g. the hero-image
 * wait) for non-human visitors: bots don't perceive jank, and gating content
 * behind a spinner only delays their measured paint (LCP) for no benefit.
 *
 * Covers Lighthouse / PageSpeed ("Chrome-Lighthouse", "Google Page Speed"),
 * prerender.io's headless Chrome, and the common search/social crawlers.
 */
const BOT_UA_PATTERN =
  /bot|crawl|spider|lighthouse|pagespeed|page speed|screaming frog|headless|prerender|slurp|duckduck|baidu|yandex|facebookexternalhit|whatsapp|telegram|embedly|preview|validator|inspectiontool|chatgpt|gptbot|claude|perplexity/i;

export const isBotUserAgent = (ua) => {
  const agent =
    ua ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  return BOT_UA_PATTERN.test(agent);
};
